import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import request from './utils/request';
import { installI18n } from './i18n';
import { FloatingPanel, Icon, Image, Popup, Swipe, SwipeItem, Switch, Tab, Tabs, Toast } from 'vant';
import 'vant/lib/floating-panel/style';
import 'vant/lib/icon/style';
import 'vant/lib/image/style';
import 'vant/lib/popup/style';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';
import 'vant/lib/switch/style';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
import 'vant/lib/toast/style';
// import VConsole from 'vconsole'
// const vconsole = new VConsole()
const app = createApp(App);
installI18n(app, router);
// 加载状态
app.use(router)
  .use(FloatingPanel)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(Swipe)
  .use(SwipeItem)
  .use(Switch)
  .use(Tab)
  .use(Tabs)
  .use(Toast)
  .mount('#app');
app.config.globalProperties.$request = request;
